import { getSettingEnableKnownReferrerAdoption } from "@faire/retailer/settings/getSettingEnableKnownReferrerAdoption";

import { useKnownReferrer } from "./useKnownReferrer";

export const useReferralDetails = () => {
  const knownRetailerReferralData = useKnownReferrer();

  if (getSettingEnableKnownReferrerAdoption()) {
    return knownRetailerReferralData;
  }

  return;
};
